import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Phpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csifelse(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  const right = {
    padding: '0 0 0 '+padding+'rem',
  };
return(
      <div>
      <Sides/>
  
      <Helmet>
 
 <title>Learn Free PHP If Else Tutorials For Beginners CodeExampler</title>
 <meta name="description" content="Php if else tutorial for beginners.if else in Php is used for making a decision.If and else can be a block statement, CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,php if else,php if else if endif,php else if vs elseif,programming language tutorial for begineers,php if else if,php if else statement,Php if else for,Php if else for loop,end for loop Php,exit while loop Php,if else foreach Php,Php foreach if else" />
 <link rel="canonical" href="https://www.codeexampler.com/php-if-else" />
 </Helmet>

 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">If else statement in Php
</h1>
<div className="first">
        <a href="/php-if">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/php-if-else-if">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
<h2 className="mt-4 mh2">If-else Syntax in Php: </h2>





      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-4">If</span>
            <span className="qwerty-6"> (</span>
            <span className="qwerty-10">condition</span>
            <span className="qwerty-6">)</span>
            {"\n"}
            <span className="qwerty-3"> &#123;</span>
            {"\n"}
            <span className="qwerty-2">Statement;</span>
            <span className="qwerty-6">; </span>
            {"\n"}
            <span className="qwerty-3"> &#125;</span>
            {"\n"}
            <span className="qwerty-6">Else</span>
            {"\n"}
            <span className="qwerty-3"> &#123;</span>
            {"\n"}
            <span className="qwerty-2">Statement;</span>
            <span className="qwerty-6">; </span>
            {"\n"}
            <span className="qwerty-3"> &#123;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>



<h2 className="headings">Q-Write a program to input a number and check this number is Greater or Less than 1000?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-4">&#60;?</span>
            <span className="qwerty-6">php</span>
            {"\n"}
            <span className="qwerty">$</span>
            <span className="qwerty-7">a </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-4">500</span>
            <span className="qwerty-3">; </span>
              {"\n"}
              <span className="qwerty-6">if</span>
            <span className="qwerty-2"> (</span>
            <span className="qwerty">$</span>
            <span className="qwerty-7">a </span>
            <span className="qwerty-3">&#62; </span>
            <span className="qwerty-4">1000</span>
            <span className="qwerty-3">) </span>
              {"\n"}
              <span className="qwerty-3"> &#123;</span>
              {"\n"} 
              <span className="qwerty-5">echo  </span>
              <span className="qwerty-2">"</span>
                <span className="qwerty-3"> This </span>
              <span className="qwerty-2"> ". </span>
              <span className="qwerty">$</span>
              <span className="qwerty-7">a </span>
              <span className="qwerty-2">." </span>
              <span className="qwerty-3">no is </span>
              <span className="qwerty-2">Greater </span>
              <span className="qwerty-3">than </span>
              <span className="qwerty-4">1000 </span>
              <span className="qwerty-2">";</span>
              {"\n"} 
              <span className="qwerty-3"> &#125;</span>
              {"\n"} 
              <span className="qwerty-6">else</span>
              {"\n"} 
              <span className="qwerty-3"> &#123;</span>
              {"\n"} 
              <span className="qwerty-5">echo  </span>
              <span className="qwerty-2">"</span>
                <span className="qwerty-3"> This </span>
              <span className="qwerty-2"> ". </span>
              <span className="qwerty">$</span>
              <span className="qwerty-7">a </span>
              <span className="qwerty-2">." </span>
              <span className="qwerty-3">no is </span>
              <span className="qwerty-2">Smaller </span>
              <span className="qwerty-3">than </span>
              <span className="qwerty-4">1000 </span>
              <span className="qwerty-2">";</span>
              {"\n"} 
              <span className="qwerty-3"> &#125;</span>
              {"\n"} 
              <span className="qwerty-4">?&#62;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
    
      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
        
              <span className="qwerty-7">This</span>
              <span className="qwerty-4"> 500 </span>
              <span className="qwerty-3">no is</span>
                <span className="qwerty-2"> Smaller</span>
              <span className="qwerty-3"> than </span>
              <span className="qwerty-4">1000 </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>


<h2 className="headings">Q-Write a program to check a no is even or odd in the Php tutorial?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-4">&#60;?</span>
            <span className="qwerty-6">php</span>
            {"\n"}
            <span className="qwerty">$</span>
            <span className="qwerty-7">a </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-4">160208</span>
            <span className="qwerty-3">; </span>
              {"\n"}
              <span className="qwerty-6">if</span>
            <span className="qwerty-2"> (</span>
            <span className="qwerty">$</span>
            <span className="qwerty-7">a </span>
            <span className="qwerty-3">% </span>
            <span className="qwerty-4">2 </span>
            <span className="qwerty-3">== </span>
            <span className="qwerty-4">0</span>
            <span className="qwerty-2">) </span>
              {"\n"}
              <span className="qwerty-3"> &#123;</span>
              {"\n"} 
              <span className="qwerty-5">echo </span>
              <span className="qwerty-2">"</span>
                <span className="qwerty-3"> This </span>
              <span className="qwerty-2">". </span>
              <span className="qwerty">$</span>
              <span className="qwerty-7">a </span>
              <span className="qwerty-2">." </span>
              <span className="qwerty-3">no is </span>
              <span className="qwerty-2">Even </span>
              <span className="qwerty-4">no </span>
              <span className="qwerty-2">";</span>
              {"\n"} 
              <span className="qwerty-3"> &#125;</span>
              {"\n"} 
              <span className="qwerty-6">else</span>
              {"\n"} 
              <span className="qwerty-3"> &#123;</span>
              {"\n"} 
              <span className="qwerty-5">echo  </span>
              <span className="qwerty-2">"</span>
                <span className="qwerty-3"> This </span>
              <span className="qwerty-2"> ". </span>
              <span className="qwerty">$</span>
              <span className="qwerty-7">a </span>
              <span className="qwerty-2">." </span>
              <span className="qwerty-3">no is </span>
              <span className="qwerty-2">Odd </span>
              <span className="qwerty-4">no </span>
              <span className="qwerty-2">";</span>
              {"\n"} 
              <span className="qwerty-3"> &#125;</span>
              {"\n"} 
              <span className="qwerty-4">?&#62;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
    
      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
        
              <span className="qwerty-7">This</span>
              <span className="qwerty-4"> 160208 </span>
              <span className="qwerty-3">no is</span>
                <span className="qwerty-2"> Even</span>
              <span className="qwerty-3"> no </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>



<h2 className="headings">Q-Write a program to find out which no is greater between two numbers in Php?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-4">&#60;?</span>
            <span className="qwerty-6">php</span>
            {"\n"}
            <span className="qwerty">$</span>
            <span className="qwerty-7">a </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-4">40</span>
            <span className="qwerty-3">; </span>
              {"\n"}
            <span className="qwerty">$</span>
            <span className="qwerty-7">b </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-4">50</span>
            <span className="qwerty-3">; </span>
              {"\n"}
              <span className="qwerty-6">if</span>
            <span className="qwerty-2"> (</span>
            <span className="qwerty">$</span>
            <span className="qwerty-7">a </span>
            <span className="qwerty-2">&#62; </span>
            <span className="qwerty">$</span>
              <span className="qwerty-7">b</span>
            <span className="qwerty-2">) </span>
              {"\n"}
              <span className="qwerty-3">&#123;</span>
              {"\n"} 
              <span className="qwerty-5"> echo </span>
              <span className="qwerty-2">"</span>
                <span className="qwerty-7"> a </span>
              <span className="qwerty-2">is </span>
              <span className="qwerty-4">greater </span>
              <span className="qwerty-2">= ".</span>
              <span className="qwerty">$</span>
              <span className="qwerty-7">a</span>
              <span className="qwerty-2">;</span>
              {"\n"} 
              <span className="qwerty-3">&#125;</span>
              {"\n"} 
              <span className="qwerty-6"> else</span>
              {"\n"} 
              <span className="qwerty-3">&#123;</span>
              {"\n"} 
              <span className="qwerty-5"> echo </span>
              <span className="qwerty-2">"</span>
                <span className="qwerty-7"> b </span>
              <span className="qwerty-2">is </span>
              <span className="qwerty-4">greater </span>
              <span className="qwerty-2">= ". </span>
              <span className="qwerty">$</span>
              <span className="qwerty-7">b</span>
              <span className="qwerty-2">;</span>
              {"\n"} 
              <span className="qwerty-3">&#125;</span>
              {"\n"} 
              <span className="qwerty-4">?&#62;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
    
      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
        
              <span className="qwerty-7">b </span>
              <span className="qwerty-3">is </span>
              <span className="qwerty-4">greater</span>
                <span className="qwerty-2"> =</span>
              <span className="qwerty-6"> 50 </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

<h2 className="mt-4 mh2">Nested list in Php tutorial:</h2>



<h2 className="headings">Q-Write a program to input a no and after Check no is Greater, Less or Between in Php Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-4">&#60;?</span>
            <span className="qwerty-6">php</span>
            {"\n"}
            <span className="qwerty">$</span>
            <span className="qwerty-7">i </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-4">840</span>
            <span className="qwerty-3">; </span>
              {"\n"}
              <span className="qwerty-6">if</span>
            <span className="qwerty-2"> (</span>
            <span className="qwerty">$</span>
            <span className="qwerty-7">i </span>
            <span className="qwerty-2">&#60; </span>
            <span className="qwerty-7">100</span>
            <span className="qwerty-2">) </span>
              {"\n"}
              <span className="qwerty-3">&#123;</span>
              {"\n"} 
              <span className="qwerty-5"> echo </span>
              <span className="qwerty-2">"</span>
                <span className="qwerty-7">i is Less than </span>
              <span className="qwerty-2">= ".</span>
              <span className="qwerty">$</span>
            <span className="qwerty-7">a</span>
              <span className="qwerty-2">;</span>
              {"\n"} 
              <span className="qwerty-3">&#125;</span>
              {"\n"} 
              <span className="qwerty-6"> else</span>
              {"\n"} 
              <span className="qwerty-3">&#123;</span>
              {"\n"}  
              <span className="qwerty-5"> if </span>
              <span className="qwerty-2">(</span>
                <span className="qwerty-7">$</span>
              <span className="qwerty-2">i</span>
              <span className="qwerty-7"> &#62;</span>
              <span className="qwerty-2">= </span>
              <span className="qwerty-7">1000</span>
              <span className="qwerty-2">)</span>
              {"\n"} 
              <span className="qwerty-3">&#123;</span>
              {"\n"} 
              <span className="qwerty-5"> echo </span>
              <span className="qwerty-2">"</span>
                <span className="qwerty-7"> Greater </span>
              <span className="qwerty-2">than </span>
              <span className="qwerty-7">1000</span>
              <span className="qwerty-2">";</span>
              {"\n"} 
              <span className="qwerty-3">&#125;</span>
              {"\n"} 
              <span className="qwerty-6"> else</span>
              {"\n"} 
              <span className="qwerty-3">&#123;</span>
              {"\n"} 
              <span className="qwerty-5"> echo </span>
              <span className="qwerty-2">"</span>
                <span className="qwerty-7"> Between </span>
              <span className="qwerty-2">100 </span>
              <span className="qwerty-4">and </span>
              <span className="qwerty-2">1000</span>
              <span className="qwerty-2">";</span>
              {"\n"} 
              <span className="qwerty-3">&#125;</span>
              {"\n"} 
              <span className="qwerty-3">&#125;</span>
              {"\n"}
              <span className="qwerty-4">?&#62;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
    
      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
        
              <span className="qwerty-7">Between </span>
              <span className="qwerty-3">100</span>
              <span className="qwerty-4"> and</span>
              <span className="qwerty-6"> 1000 </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>



<h2 className="headings">Q-Write a Nested List Program to Check Gender in Php?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-4">&#60;?</span>
            <span className="qwerty-6">php</span>
            {"\n"}
            <span className="qwerty">$</span>
            <span className="qwerty-5">sex </span>
            <span className="qwerty-2">= </span>
            <span className="qwerty-3">'</span>
            <span className="qwerty-4">m</span>
            <span className="qwerty-3">';</span>
              {"\n"}
              <span className="qwerty-10">if</span>
            <span className="qwerty-2"> (</span>
            <span className="qwerty">$</span>
            <span className="qwerty-5">sex </span>
            <span className="qwerty-2">== </span>
            <span className="qwerty-3">'</span>
            <span className="qwerty-4">m</span>
            <span className="qwerty-3">'</span>
            <span className="qwerty-2">)</span>
              {"\n"}
              <span className="qwerty-3">&#123;</span>
              {"\n"} 
              <span className="qwerty-5"> echo </span>
              <span className="qwerty-2">"</span>
                <span className="qwerty-7">This is </span>
              <span className="qwerty-2">Male </span>
   
            <span className="qwerty-7">\</span>
              <span className="qwerty">n</span>
              <span className="qwerty-2">";</span>
              {"\n"} 
              <span className="qwerty-3">&#125;</span>
              {"\n"} 
              <span className="qwerty-10"> else</span>
              {"\n"} 
              <span className="qwerty-3">&#123;</span>
              {"\n"}  
              <span className="qwerty-10"> if </span>
              <span className="qwerty-2">(</span>
                <span className="qwerty-7">$</span>
              <span className="qwerty-5">sex</span>
              <span className="qwerty-7"> == </span>
              <span className="qwerty-2">'</span>
              <span className="qwerty-4">f</span>
              <span className="qwerty-2">')</span>
              {"\n"} 
              <span className="qwerty-3">&#123;</span>
              {"\n"} 
              <span className="qwerty-5"> echo </span>
              <span className="qwerty-2">"</span>
                <span className="qwerty-7">This is </span>
              <span className="qwerty-4">Female</span>
              <span className="qwerty-2">";</span>
              {"\n"} 
              <span className="qwerty-3">&#125;</span>
              {"\n"} 
              <span className="qwerty-10"> else</span>
              {"\n"} 
              <span className="qwerty-3">&#123;</span>
              {"\n"} 
              <span className="qwerty-5"> echo </span>
              <span className="qwerty-2">"</span>
                <span className="qwerty-7">Not </span>
                <span className="qwerty-4">Male</span>
              <span className="qwerty-2"> and Not </span>
              <span className="qwerty-4">Female</span>
              <span className="qwerty-2">";</span>
              {"\n"} 
              <span className="qwerty-3">&#125;</span>
              {"\n"} 
              <span className="qwerty-3">&#125;</span>
              {"\n"}
              <span className="qwerty-5"> echo </span>
              <span className="qwerty-2">"</span>
              <span className="qwerty-6">I have checked </span>
              <span className="qwerty-2">Gender</span>
              <span className="qwerty-2">";</span>
              {"\n"} 
              <span className="qwerty-4">?&#62;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
    
      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
              <span className="qwerty-7">This </span>
              <span className="qwerty-3">is</span>
              <span className="qwerty-4"> male</span>
              {"\n"}
              <span className="qwerty-6">I have checked</span>
              <span className="qwerty-2"> Gender</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/php-if">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/php-if-else-if">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>

        </div>
    </div>
)

}
export default Csifelse;